/**
 * Controls the reusable section sub-navigation.
 */
class SubNavigation {
  constructor() {
    // Look for the sub-nav element(s)
    this.navWrappers = document.querySelectorAll('.sub-nav');
    this.headerOffset = 170; // adjust as needed (match your fixed header height)
    this.init();
  }

  init() {
    this.navWrappers.forEach(wrapper => {
      const ul = wrapper.querySelector('ul');
      const navItems = wrapper.querySelectorAll('[data-nav-link]');
      // Clean any hard‑coded active
      navItems.forEach(i => i.classList.remove('active'));

      this.setupNavigation(navItems);
      this.setupScrollSpy(navItems, ul ? ul.dataset.template : '', wrapper);
    });
  }

  // On click, smoothly scroll to the target section
   setupNavigation(items) {
    items.forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault();
        items.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
        const targetId = item.getAttribute('href').substring(1);
        const targetSection = document.getElementById(targetId);
        if (targetSection) this.scrollToSection(targetSection);
      });
    });
  }

  // Listen to scroll events and update the active nav link accordingly.
  // Also, if on mobile, horizontally scroll the active link into view.
  setupScrollSpy(items, template, wrapper) {
    // Resolve sections directly from the nav links (more robust than prefix guess)
    const sections = Array.from(items)
      .map(i => document.getElementById(i.getAttribute('href').substring(1)))
      .filter(Boolean);

    const spy = () => {
      const scrollY = window.scrollY + this.headerOffset + 2;
      let currentId = null;

      for (const section of sections) {
        const top = this.getOffsetTop(section);
        const height = section.offsetHeight || 0;
        if (scrollY >= top && scrollY < top + height) {
            currentId = section.id;
            break;
        }
      }

      // Fallback: if above first section, highlight first
      if (!currentId && sections.length) {
        if (window.scrollY + 5 < this.getOffsetTop(sections[0])) {
          currentId = sections[0].id;
        }
      }

      if (currentId) {
        items.forEach(i =>
          i.classList.toggle('active', i.getAttribute('href') === '#' + currentId)
        );
        if (window.innerWidth <= 1024) {
          const activeLink = wrapper.querySelector('[data-nav-link].active');
          if (activeLink) {
            activeLink.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        }
      }
    };

    window.addEventListener('scroll', spy, { passive: true });
    // Run once on load so first section becomes active immediately
    spy();
  }

  scrollToSection(section) {
    const elementPosition = section.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - this.headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  getOffsetTop(el) {
    let o = 0;
    while (el) { o += el.offsetTop; el = el.offsetParent; }
    return o;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SubNavigation();
});